import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { checkAdmin } from "../../utils/jwtUtils";
import { FaBars, FaTimes } from "react-icons/fa";
import { useIsMobile } from "../../hooks/useIsMobile";
import Logo from "./Logo";
import MobileMenu from "./MobileMenu";
import DesktopMenu from "./DesktopMenu";

export default function UpperBar() {
  const location = useLocation();
  const isAdmin = checkAdmin();
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useIsMobile();

  const isLogin = location.pathname === "/login";

  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && setMenuOpen(false);
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <nav
      className={`fixed w-full bg-primary-blue z-10 ${
        isMobile
          ? "min-h-[10vh]"
          : "min-h-[20vh] max-h-[20vh] flex items-center justify-between pe-10"
      }`}
    >
      <div className="flex items-center justify-between px-4 py-2">
        <Logo isMobile={isMobile} />
        {!isLogin && isMobile && (
          <button
            className="text-white text-2xl"
            aria-controls="mobile-menu"
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        )}
      </div>
      {!isLogin &&
        (isMobile ? (
          <MobileMenu
            isAdmin={isAdmin}
            menuOpen={menuOpen}
            closeMenu={() => setMenuOpen(false)}
          />
        ) : (
          <DesktopMenu isAdmin={isAdmin} closeMenu={() => setMenuOpen(false)} />
        ))}
    </nav>
  );
}
